import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { IconArrowLeft } from '@rossum/ui/icons/tabler';
import {
  IconButton,
  Stack,
  SvgIcon,
  Tooltip,
  Typography,
} from '@rossum/ui/material';
import { useNavBarVisibility } from '../../../components/NavBar/hooks/useNavBarVisibility';
import { SearchButton } from '../../../components/NavBar/SearchButton';
import PoweredBy from '../../../components/UI/PoweredBy';
import CallToActionButton from '../../../containers/CallToAction';
import { isTrialSelector } from '../../../redux/modules/organization/selectors';
import { DocumentTopBar } from '../../document-topbar';
import { useQuickSearchContext } from '../../quick-search/QuickSearchContext';
import { UserPanel } from '../../user-panel';

type NeighborsTopBarProps = {
  pageNumber: number;
  onBack: () => void;
};

/** Follows `document-split/document-topbar/SplitTopBar`. */
export const NeighborsTopBar = ({
  pageNumber,
  onBack,
}: NeighborsTopBarProps) => {
  const intl = useIntl();
  const isTrial = useSelector(isTrialSelector);
  const { isVisible: isUserPanelVisible } = useNavBarVisibility();
  const { setOpen } = useQuickSearchContext();

  const openQuickSearch = useCallback(() => {
    setOpen(true);
  }, [setOpen]);

  const title = intl.formatMessage(
    { id: 'components.neighborsDrawer.title' },
    { page: pageNumber }
  );

  const start = (
    <>
      <IconButton
        size="medium"
        color="secondary"
        data-cy="exit-route-button"
        onClick={onBack}
      >
        <SvgIcon fontSize="medium">
          <IconArrowLeft />
        </SvgIcon>
      </IconButton>
      <Stack sx={{ minWidth: 0 }}>
        <Tooltip title={title}>
          <Typography variant="h6" noWrap>
            {title}
          </Typography>
        </Tooltip>
      </Stack>
    </>
  );

  const end = (
    <>
      <SearchButton onClick={openQuickSearch} />
      {isTrial && <CallToActionButton ctaLocation="navigation-panel" />}
      <PoweredBy />
      {isUserPanelVisible ? <UserPanel /> : null}
    </>
  );

  return <DocumentTopBar start={start} center={null} end={end} />;
};
